import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'primevue/resources/themes/lara-light-indigo/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import PrimeVue from 'primevue/config';
// Fix: Import Lara theme properly based on PrimeVue 3.x syntax
// The @primevue/themes/lara import is for PrimeVue 4.x

import { LoadingPlugin } from 'vue-loading-overlay';
import VueTelInput from 'vue3-tel-input';
import Popper from "vue3-popper";

// =================================================
// Component import
import DropZone from 'dropzone-vue';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Radio from 'primevue/radiobutton';
import Dialog from 'primevue/dialog';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import Panel from 'primevue/panel';
import Calendar from 'primevue/calendar';
import ConfirmDialog from 'primevue/confirmdialog';
import Dropdown from 'primevue/dropdown';
import ConfirmationService from 'primevue/confirmationservice';
import MultiSelect from 'primevue/multiselect';
import AutoComplete from 'primevue/autocomplete';
import InputNumber from 'primevue/inputnumber';
import Steps from 'primevue/steps';
import ToggleButton from 'primevue/togglebutton';
import SelectButton from 'primevue/selectbutton';
import Textarea from 'primevue/textarea';
import RadioButton from 'primevue/radiobutton';
import ProgressBar from 'primevue/progressbar';
import Chip from 'primevue/chip';
import Checkbox from 'primevue/checkbox';
import Slider from 'primevue/slider';
import Message from 'primevue/message';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Tag from 'primevue/tag';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import ProgressSpinner from 'primevue/progressspinner';
import Badge from 'primevue/badge';
import Tooltip from 'primevue/tooltip';

import PrimeTimeline from 'primevue/timeline';
import Card from 'primevue/card';
import Listbox from 'primevue/listbox';
import Chart from 'primevue/chart';
import Toolbar from 'primevue/toolbar';
import SimpleTypeahead from 'vue3-simple-typeahead';

import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'dropzone-vue/dist/dropzone-vue.common.css';
import 'vue-loading-overlay/dist/css/index.css';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'; //Optional default CSS
import 'vue3-tel-input/dist/vue3-tel-input.css';
import './assets/login.css';
import Password from 'primevue/password';

import TutMon from "./components/tutorials/tutmon.vue";
import NavBar from "./components/navbar.vue";
import Timeline from '@/components/time_line.vue';
import ApprovalBar from '@/components/approval.vue';
import Trash from '@/components/trash.vue'
import BulkApproval from '@/components/perms/bulk_approval.vue';
import HorizontalTimeline from '@/components/perms/horizontal_timeline.vue';
import BulkUploader from '@/components/bulk_uploader.vue';
import AddressEditor from './components/address.vue';



import './assets/main.css'

const app = createApp(App)


app
.use(ToastService)
.use(store)
.use(router)
.use(DropZone)
.use(ConfirmationService)
.use(LoadingPlugin)
.use(VueTelInput)
.use(SimpleTypeahead)
.use(PrimeVue, {
    // Fix: Use the proper theme configuration for PrimeVue 3.x
    // The 'preset' syntax is for PrimeVue 4.x
    // For PrimeVue 3.x, we rely on the imported CSS themes
})

import "./style.css";

app.component("v-popper", Popper);
app.component("p-tut", TutMon);

app.component("p-calendar", Calendar);
app.component("p-calender", Calendar);  // Misspelled version used in some components
app.component("p-listbox", Listbox);
app.component("p-steps", Steps)
app.component("p-navbar", NavBar);

app.component("p-chart", Chart);

app.component("p-inputicon", InputIcon);
app.component("p-iconfield", IconField);

app.component("p-slider", Slider);
app.component("p-checkbox", Checkbox);
app.component("p-card", Card);
app.component("p-timeline", PrimeTimeline);
app.component("p-message", Message);
app.component("p-progress", ProgressBar);
app.component("p-progressBar", ProgressBar);  // Alternative naming
app.component("p-togglebutton", ToggleButton);
app.component("p-selectbutton", SelectButton);
app.component("p-toolbar", Toolbar);
app.component("p-dataTable", DataTable);
app.component("p-column", Column);
app.component("p-tabPanel", TabPanel);
app.component("p-autocomplete", AutoComplete);
app.component("p-multiselect", MultiSelect);
app.component("p-dropdown", Dropdown);
app.component("p-chip", Chip);
app.component("p-radio", Radio)

app.component("ConfirmDialog", ConfirmDialog);
app.component("p-confirmDialog", ConfirmDialog);
app.component("p-radiobutton", RadioButton);
app.component("p-textarea", Textarea);
app.component("p-panel", Panel);
app.component("p-toast", Toast);

app.component("p-dialog", Dialog);
app.component("p-text", InputText);
app.component("p-inputText", InputText);
app.component("p-inputtext", InputText);
app.component("p-number", InputNumber);
app.component("p-inputNumber", InputNumber);
app.component("p-inputnumber", InputNumber);
app.component("p-progressspinner", ProgressSpinner);

// app.component("p-column", Column); // Removed duplicate - already registered above
app.component("p-table", DataTable);
app.component("p-datatable", DataTable);
app.component("p-button", Button);

app.component("approval-bar", ApprovalBar);
app.component("bulk-approve", BulkApproval);
app.component("b-uploader", BulkUploader);
app.component("horizontal-timeline", HorizontalTimeline);
// eslint-disable-next-line
app.component("timeline", Timeline);

app.component("u-address", AddressEditor)
app.component("p-trash", Trash)
app.component('AppPassword', Password);
app.component('p-password', Password);
app.component('AppButton', Button);
app.component('AppCheckbox', Checkbox);
app.component('AppMessage', Message);
app.component('InputText', InputText);
app.component('p-tag', Tag);
app.component('p-tabview', TabView);
app.component('p-tab-panel', TabPanel);
app.component('p-tabpanel', TabPanel);
app.component('p-badge', Badge);
app.directive('tooltip', Tooltip);

app.mount('#app')

